<template>
  <div class="information-dialog-view">
    <el-dialog
      title="企业信息"
      :visible.sync="dialogVisible"
      :show-close="false"
      custom-class="information-dialog"
      :lock-scroll="false"
      @close="handleMouseLeave"
    >
      <div class="content" @mouseleave="handleMouseLeave">
        <div class="content-header">
          <div class="title">企业信息</div>
        </div>
        <div class="content-top">
          <div class="company-info">
            <img src="../../assets/img/detail/company-icon.svg" />
            <div class="text">
              <div class="name">****************{{ informationObj.name }}</div>
              <div class="tags">
                <div class="tag">{{ informationObj.regStatus }}</div>
                <div class="tag">{{ informationObj.companyOrgType }}</div>
              </div>
            </div>
          </div>
          <div class="top-operate">
            <div class="determine-login-status" @click="determineLoginStatus('收藏')">
              <img src="../../assets/img/detail/collect-icon.svg" />
              收藏
            </div>
            <div class="line"></div>
            <div class="determine-login-status" @click="determineLoginStatus('监控业务形态')">
              <img src="../../assets/img/detail/monitor-icon.svg" />
              监控业务形态
            </div>
          </div>
        </div>
        <div class="num-block">
          <div class="num-single">
            <div class="num-info" @click="determineLoginStatus('联系人')">
              <span>{{ informationObj.companyContacts }}</span>
              <span>个</span>
              <img src="../../assets/img/detail/arrow-right.svg" />
            </div>
            <span class="label">联系人</span>
          </div>
          <div class="num-single">
            <div class="num-info" @click="determineLoginStatus('历史招标')">
              <span>{{ informationObj.winningCount }}</span>
              <span>条</span>
              <img src="../../assets/img/detail/arrow-right.svg" />
            </div>
            <span class="label">历史招标</span>
          </div>
          <div class="num-single">
            <div class="num-info" @click="determineLoginStatus('历史中标')">
              <span>{{ informationObj.bidCount }}</span>
              <span>条</span>
              <img src="../../assets/img/detail/arrow-right.svg" />
            </div>
            <span class="label">历史中标</span>
          </div>
        </div>
        <div class="tip-text">
          <img src="../../assets/img/detail/jiami-icon.svg" />
          <span>咨询</span>
          <span class="main-color main-color-tel">400-688-2000</span>
          <span>查看全部商机</span>
          <a class="service-hotline-box" :href="SALE_BEFORE_URL" target="_blank">
            <img src="../../assets/img/detail/icon_service_hotline.svg" alt="" />
            <span>在线咨询</span>
          </a>
        </div>
        <div class="contact-information">
          <div class="info">
            <span class="label">电话：</span>
            <span>{{
              informationObj.phoneNumber === "暂无" ? "暂无" : `${informationObj.phoneNumber}************`
            }}</span>
          </div>
          <div class="info">
            <span class="label">邮箱：</span>
            <span>{{ informationObj.email === "暂无" ? "暂无" : `${informationObj.email}********` }}</span>
          </div>
          <div class="info">
            <span class="label">地址：</span>
            <span>{{
              informationObj.address === "暂无" ? "暂无" : `${informationObj.address}******************************`
            }}</span>
          </div>
        </div>
        <div class="btn-block">
          <div class="btn" @click="determineLoginStatus('招中标记录')">招中标记录</div>
          <div class="btn" @click="determineLoginStatus('企业背景')">企业背景</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DEED_MAP, OID_MAP } from "../../utils/constants/constants.track";
import { SALE_BEFORE_URL } from "../../utils/constants/constants";
export default {
  name: "LibDetailInformationDialog",

  props: {
    showDialog: {
      type: Boolean,
      default: () => false,
    },
    informationObj: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    showDialog(val) {
      this.dialogVisible = val;
    },
  },

  data() {
    return {
      dialogVisible: false,
      currentPage: window.location.href,
      SALE_BEFORE_URL,
    };
  },
  methods: {
    handleMouseLeave() {
      this.$emit("closeShowInformationDialog");
    },
    determineLoginStatus(btnText) {
      this.$track(DEED_MAP.CLICK, OID_MAP.DETAIL_ENTERPRISE_INFORMATION_POPUP, {
        extendinfo: btnText,
      });
      // this.$emit("loginStatusOperate");
      this.showLoginDialog();
    },
    showLoginDialog() {
      this.$store.commit("basic/updateIsShowDialogLogin", true);
      this.$store.commit("basic/updateLoginSuccessGo", {
        type: "href",
        url: this.currentPage,
      });
    },
  },
};
</script>

<style lang="scss">
.information-dialog {
  width: 607px !important;
  height: 482px;
  background: #ffffff;
  border-radius: 4px !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 24px;
  }
}
</style>
<style lang="scss" scoped>
.information-dialog {
  .main-color-tel {
    font-weight: 550;
  }

  .content-header {
    padding-bottom: 12px;
    margin-bottom: 24px;
    padding-left: 0;
    border-bottom: 1px solid #eeeef0;

    .title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 550;
      color: #2a2b33;
    }
  }
  .determine-login-status {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .content-top {
    display: flex;
    justify-content: space-between;
    position: relative;

    img {
      margin-right: 6px;
    }
  }

  .company-info {
    display: flex;
    flex: 1;
    img {
      margin-right: 16px;
    }

    .name {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 550;
      text-align: left;
      color: #17181a;
      line-height: 22px;
    }

    .tags {
      margin-top: 6px;
      display: flex;

      .tag {
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        text-align: left;
        color: #77bc66;
        line-height: 16px;
        padding: 2px 10px;
        background: #f0f8ef;
        margin-right: 8px;
        min-width: 46px;
        height: fit-content;
        &:last-child {
          color: #5183f7;
          background: #edf4fe;
        }
      }
    }
  }

  .top-operate {
    display: flex;
    color: #df6250;
    height: 14px;
    align-items: center;
    width: 190px;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    .line {
      width: 1px;
      height: 14px;
      background: #eeeef0;
      margin: 0 12px;
    }
  }

  .num-block {
    margin-top: 24px;
    width: 559px;
    height: 100px;
    background-image: url("../../assets/img/detail/num-block-bg.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .num-single {
    .label {
      color: #45464a;
    }
  }

  .num-info {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: center;
    color: #df6250;
    line-height: 33px;
    cursor: pointer;

    span {
      &:nth-child(2) {
        font-size: 14px;
      }
    }
  }

  .tip-text {
    display: flex;
    align-items: center;
    margin-top: 24px;

    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #45464a;
    line-height: 20px;

    .main-color {
      color: #df6250;
      margin: 0 4px;
    }

    img {
      margin-right: 8px;
    }
    .service-hotline-box {
      width: 84px;
      height: 24px;
      border: 1px solid #df6250;
      border-radius: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 16px;
      cursor: pointer;
      padding-right: 1px;
      img {
        margin-right: 0px;
        width: 14px;
        height: 14px;
      }
      span {
        font-size: 12px;
        color: #df6250;
        margin-left: 3px;
      }
    }
  }

  .contact-information {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #45464a;
    line-height: 20px;

    .info {
      margin-top: 12px;
    }

    .label {
      color: #7c7d81;
    }
  }

  .btn-block {
    padding-left: 30px;
    margin-top: 24px;
    display: flex;

    .btn {
      width: 150px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #df6250;
      border-radius: 33px;
      text-align: center;
      cursor: pointer;

      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 550;
      text-align: center;
      color: #df6250;
      line-height: 38px;

      &:nth-child(2) {
        margin: 0 24px;
      }

      &:last-child {
        border: 1px solid #dedee2;
        color: #45464a;
        font-weight: 400;
      }
    }
  }
}
</style>
